// SPDX-License-Identifier: Apache-2.0
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var Assets_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodePackedAssets = exports.Assets = exports.ETHZERO = void 0;
const ethers_1 = require("ethers");
const typedjson_1 = require("../../export/typedjson");
const asset_1 = require("./asset");
const util_1 = require("../../api/util");
const ledger_1 = require("./..");
const amount_1 = require("./amount");
const tokens_1 = require("./tokens");
exports.ETHZERO = "0x0000000000000000000000000000000000000000";
let Assets = Assets_1 = class Assets {
    constructor(...assets) {
        this.values = new Map();
        assets.forEach(({ token, asset }) => this.addAsset(token, asset));
    }
    static toJSON(me) {
        var obj = {};
        me.values.forEach((v, k) => {
            var withTypeEncoded = {};
            withTypeEncoded[v.typeTag()] = v.toJSON();
            obj[k] = withTypeEncoded;
        });
        return obj;
    }
    static fromJSON(data) {
        const vs = new Assets_1();
        for (const k in data) {
            if (!ethers_1.utils.isAddress(k)) {
                throw new Error(`decoding asset with malformed address: ${k}`);
            }
            // Make sure addresses are lowercase keys and not checksum encoded.
            vs.values.set(ledger_1.addressKey(k), asset_1.Asset.fromJSON(data[k]));
        }
        return vs;
    }
    ABIType() {
        return "tuple(address token,bytes value)[]";
    }
    asABI() {
        return this.orderedAssets().map(([addr, asset]) => {
            return {
                token: addr,
                value: asset.asABI(),
            };
        });
    }
    orderedAssets() {
        let assets = [];
        for (const entry of this.values.entries()) {
            assets.push(entry);
        }
        return assets.sort(([addr1, _], [addr2, __]) => {
            return addr1.localeCompare(addr2);
        });
    }
    hasAsset(addr) {
        return this.values.has(ledger_1.addressKey(addr));
    }
    addAssets(assets) {
        const it = assets.values.entries();
        for (let next = it.next(); !next.done; next = it.next()) {
            const [k, v] = next.value;
            this.addAsset(k, v);
        }
    }
    addAsset(addr, asset) {
        addr = ledger_1.addressKey(addr);
        if (asset.zero()) {
            return;
        }
        if (this.values.has(addr)) {
            this.values.get(addr).add(asset);
        }
        else {
            this.values.set(addr, asset);
        }
    }
    cmp(assets) {
        const res = ["lt", "eq", "gt"];
        let swap = 1;
        let cmp = 0;
        let a = this.values;
        let b = assets.values;
        if (a.size < b.size) {
            a = b;
            b = this.values;
            swap = -1;
        }
        if (!isProperSubset(b, a)) {
            return "uncomparable";
        }
        const it = a.entries();
        for (let next = it.next(); !next.done; next = it.next()) {
            const [k, va] = next.value;
            const bHasNotToken = !b.has(k);
            if (bHasNotToken && cmp === -1) {
                return "uncomparable";
            }
            else if (bHasNotToken) {
                cmp = 1;
                continue;
            }
            const vb = b.get(k);
            const r = va.cmp(vb);
            if (r === "uncomparable") {
                return r;
            }
            else if ((r === "lt" && cmp === 1) ||
                (r === "gt" && cmp === -1)) {
                return "uncomparable";
            }
            else if (r !== "eq" && cmp === 0) {
                cmp = res.indexOf(r) - 1;
            }
        }
        return res[cmp * swap + 1];
    }
};
Assets = Assets_1 = __decorate([
    typedjson_1.jsonObject,
    __metadata("design:paramtypes", [Object])
], Assets);
exports.Assets = Assets;
function isProperSubset(presumedSubset, presumedSuperset) {
    const it = presumedSubset.keys();
    for (let k = it.next(); !k.done; k = it.next()) {
        if (!presumedSuperset.has(k.value)) {
            return false;
        }
    }
    return true;
}
async function decodePackedAssets(erdstall, tokenProvider, values) {
    const assets = new Assets();
    for (const [t, v] of values) {
        const ttype = await tokenProvider.tokenTypeOf(erdstall, t);
        assets.addAsset(t, decodePackedAsset(v, ttype));
    }
    return assets;
}
exports.decodePackedAssets = decodePackedAssets;
function decodePackedAsset(data, ttype) {
    switch (ttype) {
        case "ETH": {
            return amount_1.decodePackedAmount(data);
        }
        case "ERC20": {
            return amount_1.decodePackedAmount(data);
        }
        case "ERC721": {
            const res = tokens_1.decodePackedIds(data);
            return new tokens_1.Tokens(res);
        }
        case "ERC721Mintable": {
            const res = tokens_1.decodePackedIds(data);
            return new tokens_1.Tokens(res);
        }
    }
}
util_1.customJSON(Assets);
//# sourceMappingURL=assets.js.map